module.exports = __webpack_public_path__ + "697040aa8af400e8b068a41dee36ed71.jpg";